import React, { useState } from 'react';

const MarkdownImage = ({ src, alt, title }) => {
  const [imageError, setImageError] = useState(false);
  
  // Handle relative paths - convert json/ to public path
  const imageSrc = src?.startsWith('json/') 
    ? src.replace('json/', '/json/')
    : src;

  if (imageError) {
    return (
      <div className="my-4 text-center">
        <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg p-6 text-gray-600 inline-block max-w-md">
          <div className="flex flex-col items-center">
            <svg className="w-12 h-12 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 00-2-2H6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p className="font-medium text-gray-700">{alt || 'Image not found'}</p>
            <p className="text-sm text-gray-500 mt-1">Path: {src}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="my-4 text-center">
      <img
        src={imageSrc}
        alt={alt || 'Image'}
        title={title}
        className="max-w-full h-auto mx-auto rounded-lg shadow-md"
        onError={() => setImageError(true)}
      />
    </div>
  );
};

export default MarkdownImage;